import { render } from "./DialogBox.vue?vue&type=template&id=58ff9fc7&scoped=true"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"

import "./DialogBox.vue?vue&type=style&index=0&id=58ff9fc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ff9fc7"]])

export default __exports__